import { connect } from 'react-redux'

import Component from './Statistics'

const mapActionCreators = {
}

const mapStateToProps = (state) => ({

})

export default connect(mapStateToProps, mapActionCreators)(Component)



// WEBPACK FOOTER //
// ./src/containers/statistics/index.js